// @ts-ignore
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getCookie, setCookie } from '../utils/cookieUtils';

// Импорт переводов
import translationRU from './locales/ru/translation.json';
import translationIT from './locales/it/translation.json';

// Объект ресурсов с переводами
const resources = {
    ru: {
        translation: translationRU
    },
    it: {
        translation: translationIT
    }
};

// Пользовательский детектор языка, который отдает приоритет cookie
const customLanguageDetector = {
    name: 'customDetector',
    lookup: () => {
        // Проверяем и синхронизируем куки
        const languageCookie = getCookie('language');
        const i18nextCookie = getCookie('i18next');

        // Если есть языковая кука, но нет i18next куки, устанавливаем ее
        if (languageCookie && !i18nextCookie) {
            setCookie('i18next', languageCookie, 30);
        }
        // Если есть i18next, но нет language, установим language
        else if (i18nextCookie && !languageCookie) {
            setCookie('language', i18nextCookie, 30);
        }
        // Если обе куки есть, но они разные, приоритет у language
        else if (languageCookie && i18nextCookie && languageCookie !== i18nextCookie) {
            setCookie('i18next', languageCookie, 30);
            return languageCookie;
        }

        return languageCookie || i18nextCookie || localStorage.getItem('i18nextLng') || 'ru';
    },
    cacheUserLanguage: (lng: string) => {
        // При сохранении языка в i18next, обновляем обе куки
        setCookie('language', lng, 30);
        setCookie('i18next', lng, 30);
        localStorage.setItem('i18nextLng', lng);
    }
};

/**
 * Инициализация i18next с интеграцией React
 * Настроено с:
 * - Пользовательским детектором языка, который отдает приоритет cookie
 * - Детектором языка браузера
 * - Поддержкой русского и итальянского языков
 * - Резервным языком - русский
 */
i18n
    .use(LanguageDetector)  // Определение языка из браузера/localStorage
    .use(initReactI18next)  // Интеграция React i18next
    .init({
        resources,
        fallbackLng: 'ru',    // Язык по умолчанию
        interpolation: {
            escapeValue: false  // Не нужно для React, так как он экранирует по умолчанию
        },
        detection: {
            order: ['customDetector', 'cookie', 'localStorage', 'navigator'],  // Порядок определения
            caches: ['cookie', 'localStorage']  // Что использовать для кэширования настроек языка
        },
        load: 'languageOnly',  // Избегать загрузки файлов для конкретных регионов (ru-RU → ru)
        // Не преобразовывать регистр языка для поддержания одинаковых кодов языков
        lowerCaseLng: true
    });

// Регистрация пользовательского детектора
i18n.services?.languageDetector?.addDetector?.(customLanguageDetector);

export default i18n; 